/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react';

const Pagination = ({arrLength, limit, offset, setOffset, children, compact = false}) => {
  const [buttons, setButtons] = useState([]);

  useEffect(() => {
    const newButtons = [];
    const pageCount = Math.ceil(arrLength / limit);
    for (let page = 1; page <= pageCount; page++) {
      if (!compact || pageCount <= 7 || page === 1 || page === pageCount || Math.abs(page - offset) <= 1 || (offset <= 3 && page <= 4) || (offset >= pageCount - 2 && page >= pageCount - 3)) {
        if (newButtons.length && page - newButtons[newButtons.length - 1] > 1) {
          newButtons.push(`gap-${page}`);
        }
        newButtons.push(page);
      }
    }
    setButtons(newButtons);
  }, [arrLength, limit, offset, compact]);

  return (
    <>
      {children}
      <div className='d-flex flex-stack flex-wrap pt-10'>
        <div className='fs-6 fw-semibold text-gray-700'>{/* Showing 1 to 10 of 50 entries */}</div>

        <ul className='pagination'>
          <li
            className='page-item previous cursor-pointer'
            onClick={() => {
              if (offset > 1) {
                setOffset(offset - 1);
              }
            }}
          >
            <span className='page-link'>
              <i className='previous'></i>
            </span>
          </li>
          {buttons.map((page) => {
            if (typeof page !== 'number') {
              return <li className='page-item disabled' key={page}><span className='page-link'>...</span></li>;
            }
            return (
              <li
                className={`page-item cursor-pointer ${page === offset ? 'active' : ''}`}
                key={`${page}-pag`}
                onClick={() => setOffset(page)}
              >
                <span className='page-link'>{page}</span>
              </li>
            );
          })}
          <li
            className='page-item next cursor-pointer'
            onClick={() => {
              if (offset * limit < arrLength) {
                setOffset(offset + 1);
              }
            }}
          >
            <span className='page-link'>
              <i className='next'></i>
            </span>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Pagination;
